import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IListReportNamesData, IListReportNamesResponse } from '../types';
import { LIST_REPORT_NAMES_API_URL, LIST_REPORT_NAMES_QUERY, ROLES_PERMISSIONS } from '../constants';

export default function useListReportNamesQuery(
  enabled: Ref<boolean>,
): IContextQueryResult<IListReportNamesResponse, Error, IListReportNamesData> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IListReportNamesResponse, Error, IListReportNamesData>({
    queryKey: [LIST_REPORT_NAMES_QUERY],
    queryFn: ({ signal }) => fetchGet<IListReportNamesResponse>(LIST_REPORT_NAMES_API_URL, {
      signal,
      permission: ROLES_PERMISSIONS.REPORT_FIELDS,
    }),
    select: (data) => data.list_report_fields,
    enabled,
  });
}
